import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import HomePage from '../components/HomePage';
import iconDevice from '../medias/device.svg';
import iconPacket from '../medias/packet.svg';
import iconSite from '../medias/site.svg';
import iconMore from '../medias/more.svg';

class HomeOfAgent extends Component {
  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.agentSites(callback)
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(params, {
          success: callback
        })
      },
      agentStatistic: (params, callback) => {
        DataFetcher.agentStatistic(params, {
          success: callback
        })
      },
      siteStatistic: (params, callback) => {
        DataFetcher.siteStatistic(params, {
          success: callback
        })
      },
      deviceRevenueLink: (record) => {
        return `/agent/device_revenue/${record.siteId}`
      },
      menuData: [
        { name: '设备管理', icon: iconDevice, link: '/device' },
        { name: '套餐设置', icon: iconPacket, link: '/packet' },
        { name: '门店管理', icon: iconSite, link: '/site', style: {width: 35} },
        { name: '更多功能', icon: iconMore, link: '/agent/more' },
      ]
    }

    return <HomePage {...pageProps}/>
  }
}

export default HomeOfAgent;


// WEBPACK FOOTER //
// ./src/modules/HomeOfAgent.js